import React, { useEffect } from 'react';
import { ERouteLinks } from 'models/route';
import { Grid, Typography } from '@mui/material';
import Button from 'components/atoms/Button';
import { FormInput } from 'components/molecules/FormInput';
import { initialAccountDataFormValues } from 'models/form';
import { useForm } from 'react-hook-form';
import { useDictionary } from 'models/dictionaryContext';
import { yupResolver } from '@hookform/resolvers/yup';
import { EButtonVariants } from 'constants/Buttons';
import { useNavigate } from 'react-router-dom';
import { FormSelect } from 'components/molecules/FormSelect';
import { mapDictionaryToOptionProp } from 'helpers/dictionary';
import { FormCheckbox } from 'components/molecules/FormCheckbox';
import { useTranslation } from 'react-i18next';
import useEditAccountDataFormSchema from 'pages/MyProfilePage/EditAccountDataPage/schemaValidation';

interface IEditAccountDataForm {
  toConfirm: (data: any) => void;
}

const EditAccountDataForm = ({ toConfirm }: IEditAccountDataForm) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { phoneCode, getPhoneCode } = useDictionary();
  const { schema } = useEditAccountDataFormSchema();
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues: initialAccountDataFormValues, resolver: yupResolver(schema) as any });

  useEffect(() => {
    if (!phoneCode) {
      getPhoneCode();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (data: any) => {
    // eslint-disable-next-line no-console
    console.log(data); // TO DO DELETE
    toConfirm(data);
  };

  useEffect(() => {
    // TO DO DELETE
    setValue('prefixPhoneNumberUniqueId', '15dc4386-cc75-11ec-9d64-0242ac120002');
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
      <Grid item container xs={12} gap={3}>
        <Grid item xs={12} gap={2}>
          <Grid item container xs={12} columnSpacing={3} rowGap={1}>
            <Grid item xs={12} sm={6}>
              <FormInput
                name="email"
                label={t('page.myProfile.accountData.edit.input.emailAddress')}
                control={control}
                errors={errors}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormInput
                name="retypeEmail"
                label={t('page.myProfile.accountData.edit.input.retypeEmailAddress')}
                control={control}
                errors={errors}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormSelect
                name="prefixPhoneNumberUniqueId"
                options={mapDictionaryToOptionProp(phoneCode)}
                label={t('page.myProfile.accountData.edit.select.prefixPhoneNumber')}
                control={control}
                setValue={setValue}
                errors={errors}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormInput
                name="phoneNumber"
                label={t('page.myProfile.accountData.edit.input.phoneNumber')}
                control={control}
                errors={errors}
                required
              />
            </Grid>
            <Grid item container alignItems="baseline" xs={12}>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ fontWeight: 700 }}>
                  {t('page.myProfile.accountData.edit.label.notification')}
                </Typography>
              </Grid>
              <Grid item container xs={12} gap={2}>
                <FormCheckbox
                  name="notificationEmail"
                  label={t('page.myProfile.accountData.edit.checkbox.email')}
                  control={control}
                  errors={errors}
                />
                <FormCheckbox
                  name="notificationSms"
                  label={t('page.myProfile.accountData.edit.checkbox.sms')}
                  control={control}
                  errors={errors}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container xs={12} columnSpacing={3} rowGap={1}>
          <Grid item xs={12} sm={6}>
            <Button
              id="save"
              type="submit"
              label={t('page.myProfile.accountData.edit.button.save')}
              variant={EButtonVariants.contained}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              id="signin"
              label={t('page.createAccount.button.cancel')}
              variant={EButtonVariants.outlined}
              onClick={() => navigate(ERouteLinks.MyProfile)}
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export { EditAccountDataForm };
